module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "sold-acc"
  }, [_c('latestnews'), _vm._v(" "), _c('pricelist', {
    attrs: {
      "title": '已售账号',
      "data": _vm.goodList,
      "page": _vm.goodsPage,
      "type": 2
    },
    on: {
      "showlogin": _vm.showLogin,
      "changepage": _vm.changeGoodsPage,
      "changepagesize": _vm.changeGoodsPageSize
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3d039723"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/soldAcc/soldAcc.vue
// module id = 624
// module chunks = 31